import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Flex } from 'antd';
import dayjs from 'dayjs';

// services
import { downloadFile } from 'utils/downloadFile';

// styles
import styles from '../pages/dataRoom.module.scss';

//models
import { FileHistory, FileHistoryItem } from '../models/data';

interface DataRoomItemProps {
	file: FileHistory;
}

const DataRoomItem: FunctionComponent<DataRoomItemProps> = ({ file }) => {
	const { t } = useTranslation();

	const downloadHandler = async (file: FileHistoryItem) => {
		await downloadFile(file.download_link, file.title);
	};

	return (
		<>
			<div className={styles.oldFiles}>
				{file.history.map((item, index) => (
					<div key={index} className={styles.oldFiles_item}>
						<Flex justify="space-between" align="center">
							<p className="mb-0 text-light">{dayjs(item.last_modified_date).format('YYYY-MM-DD HH:mm A')}</p>

							<Button type="primary" size="middle" onClick={() => downloadHandler(item)}>
								{t('COMMON.DOWNLOAD')}
							</Button>
						</Flex>
					</div>
				))}
			</div>
		</>
	);
};

export default DataRoomItem;
